<p>dashboard-location-preferences-error works!</p>
